import type { Nullable } from "@msuite/utils/types";
import type { PropsWithChildren } from "react";
import { cn } from "../utils";

/** Props Interface */
interface SettingsItemProps extends PropsWithChildren {
	title: string;
	description: Nullable<string>;
}

export function SettingsItem({ title, description, children }: SettingsItemProps) {
	/** Render */
	return (
		<div
			className={cn(
				"px-5 -mx-4 -my-2 pb-4 pt-5",
				// if is not last item, add border
				"first:-mt-5",
				"last:-mb-4",
				"not-last:border-b-[0.5px] border-color",
			)}
		>
			<div
				className="grid items-center"
				style={{ gridTemplateColumns: "1fr auto" }}
			>
				<div className="v-stack gap-1 max-w-[70%]">
					<p className="text-sm font-semibold">{title}</p>
					{description && <p className="label">{description}</p>}
				</div>
				<div>{children}</div>
			</div>
		</div>
	);
}
